import Vue from 'vue'
import Vuex from 'vuex'
import accountState from '@/app/model/store/domain/AccountState/index'
import groupState from '@/app/model/store/domain/GroupState/index'
import plantState from '@/app/model/store/domain/PlantState/index'
import riskState from '@/app/model/store/domain/RiskState/index'
import varietyState from '@/app/model/store/domain/VarietyState/index'
import varietyGrowthState from '@/app/model/store/domain/VarietyGrowthState/index'
import masterFieldState from '@/app/model/store/domain/MasterFieldState/index'
import machineState from '@/app/model/store/domain/MachineState/index'
import weedState from '@/app/model/store/domain/WeedState/index'
import machineRentState from '@/app/model/store/domain/MachineRentState/index'
import spFieldState from '@/app/model/store/domain/SpFieldState/index'
import areaState from '@/app/model/store/domain/AreaState/index'
import districtState from '@/app/model/store/domain/DistrictState/index'
import alertState from '@/app/model/store/domain/AlertState/index'
import routeState from '@/app/model/store/domain/RouteState/index'
import dateChoiceState from '@/app/model/store/domain/DateChoiceState/index'
import stageUpdateState from '@/app/model/store/domain/StageUpdateState/index'
import mapState from '@/app/model/store/domain/MapState/index'
import fieldState from '@/app/model/store/domain/FieldState/index'
import camImageState from '@/app/model/store/domain/CamImageState/index'
import fieldChoiceState from '@/app/model/store/domain/FieldChoiceState/index'
import fieldDetailsState from '@/app/model/store/domain/FieldDetailsState/index'
import graphState from '@/app/model/store/domain/GraphState/index'
import graphToggleState from '@/app/model/store/domain/GraphToggleState/index'
import fieldOrderState from '@/app/model/store/domain/FieldOrderState/index'
import profitState from '@/app/model/store/domain/ProfitState/index'
import setFlagState from '@/app/model/store/domain/SetFlagState/index'
import aiAdviceState from '@/app/model/store/domain/AiAdviceState/index'
import newsBoardState from '@/app/model/store/domain/NewsBoardState/index'
import externalLinkState from '@/app/model/store/domain/ExternalLinkState/index'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    accountState,
    groupState,
    plantState,
    riskState,
    varietyState,
    varietyGrowthState,
    masterFieldState,
    machineState,
    weedState,
    machineRentState,
    spFieldState,
    areaState,
    districtState,
    alertState,
    routeState,
    dateChoiceState,
    stageUpdateState,
    mapState,
    fieldState,
    camImageState,
    fieldChoiceState,
    fieldDetailsState,
    graphState,
    graphToggleState,
    fieldOrderState,
    profitState,
    setFlagState,
    aiAdviceState,
    newsBoardState,
    externalLinkState
  }
})
